import FlourishDeck from "./FlourishDeck";

const FlourishProposal = () => <FlourishDeck />;

export default FlourishProposal;
